import './GradientDot.css';

export default function GradientDot({ size = 12, className = '' }) {
  const classes = ['GradientDot', className].filter(Boolean).join(' ');
  return <span className={classes} style={{ width: size, height: size }} aria-hidden="true" />;
}
